import React, { useEffect, useState,useContext,useRef } from 'react';
import AppContext from "../AppContext"
import { Row,Divider,Col,Space,Modal,Form,Select,Input,Upload,Button,Collapse,message,Typography,List, Popconfirm, Table } from 'antd';
import { GetTranslation } from '../../Models/shared/general';
import {
    onLoadPaymentAcct,
    onUpdatePaymentAcct
} from '../../Controller/Management/PaymentManagement'

import IconButton from '@mui/material/IconButton';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';

import TextField from '@mui/material/TextField';

import Autocomplete from '@mui/material/Autocomplete';
import { DownloadOutlined,SearchOutlined,CheckOutlined,CloseOutlined } from '@ant-design/icons';

import Highlighter from 'react-highlight-words';

import Backdrop from '@mui/material/Backdrop';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import CircularProgress from '@mui/material/CircularProgress';

export default function PaymentAcctManagement(prop) {


    const userlang                                              = navigator.language || navigator.userLanguage;

    const [Mpaymentacct, setMpaymentacct]                       = useState();
    const [Mcurrency, setMcurrency]                             = useState();
    
    const [ModalEditVisible, setModalEditVisible]               = useState(false)
    const [CreateForm,setCreateForm]                            = useState(true)
    const [Pobjid, setPobjid]                                   = useState('')
    const [Ppayid, setPpayid]                                   = useState('')
    const [Ppaydesc, setPpaydesc]                               = useState('')
    const [Pcurrency, setPcurrency]                             = useState('')
    
    const [opendialog,setopendialog]                            = useState(false)
    const [dialogtitle,setdialogtitle]                          = useState("")
    const [dialogstatus,setdialogstatus]                        = useState("")

    const [ProgressStatus, setPogressStatus]                    = useState(false);

    const [search, setSearch] = useState({ Text: "", Column: "" })


    const getColumnSearchProps = (dataIndex, title) => ({

        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>

                <Input
                   
                    autoFocus={true}
                    placeholder={`Search ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => {
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                        //handleSearch(e.target.value, confirm, dataIndex)
                    }}
                    onKeyDown={e => {
                        if (e.key === 'Enter') {
                            //setSelectedKeys(e.target.value ? [e.target.value] : [])
                            handleSearch(e.target.value, confirm, dataIndex)
                        }
                    }}
                    style={{ width: 200, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        data-reset='reset'
                        type="link"
                        onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? "crimson" : undefined }} />,

        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',

        render: (text) =>
            search.Column === dataIndex ?
                (
                    <Highlighter
                        highlightStyle={{ backgroundColor: "gold", padding: 0 }}
                        searchWords={[search.Text]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                )
                : (
                    text
                ),


    });
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm({ closeDropdown: false });
        setSearch({
            Text: selectedKeys,
            Column: dataIndex,
        });
     
    };
    const handleReset = clearFilters => {
        clearFilters({ closeDropdown: false });
        setSearch({ Column: search.Column, Text: '' });
    };

    function Pcurrencychange(e,type,e2)
    {
      if(e != null)
      {

        if(type == 1)
        {
            setPcurrency(e.value)
          
        }
        else if(type ==2)
        {
          
            setPcurrency(e.toUpperCase())
         
        }
        

      }
    }

    function handleSnackClose()
    {
        setopendialog(false)
       
    }
    async function LoadPaymentAcctListing()
    {
        var result = await onLoadPaymentAcct({type : 'all'})

        const groupedCURR = result.data.reduce((groups, item) => {
            const { currency } = item;
            const key = `${currency}`;
            if (!groups[key]) {
              groups[key] = { text :currency,value :currency,label:currency };
            } else {
            }
            return groups;
          }, {});

         let tempcurrency = Object.values(groupedCURR)
         tempcurrency = tempcurrency.filter((x) => x.value != undefined)
         tempcurrency = tempcurrency.sort((a,b)=> (a.value.toString().localeCompare(b.value.toString())))

        setMcurrency(tempcurrency)

        setMpaymentacct(result.data)
        
    }
    async function UpdatePaymentAcctStatus(data)
    {
        let temppaymentacct = Mpaymentacct

        setPogressStatus(true)
        let data1 = {
            payid         : data.payid,
            active      : !data.active
        }

      
        var result1 = await onUpdatePaymentAcct(data1)
       
        if(result1.status == 'ok')
        {
            
            setdialogtitle("Update Successfully!")
            setdialogstatus("success")
            setopendialog(true)
        }
        else
        {
            setdialogtitle("Update fail, please contact IT!")
            setdialogstatus("error")
            setopendialog(true)
        }
        temppaymentacct = temppaymentacct.map(x => x._id === data._id ? ({...x, active: !data.active} ) : (x))

        setPogressStatus(false)
        setMpaymentacct(temppaymentacct)
       
    }
    function handleModalOpen(data,type)
    {
        if(type == 1)
        {
            setCreateForm(true)
            setPpayid(data.payid)
            setPpaydesc(data.paydesc)
            setPcurrency(data.currency)
            
        }
        else if(type == 2)
        {
            setCreateForm(false)
            setPpayid('')
            setPpaydesc('')
            setPcurrency('')
        }
      
        
        setModalEditVisible(true)
       
    }
    function handleModalClose(data)
    {
        setCreateForm(true)
        setPpayid('')
        setPpaydesc('')
        setPcurrency('')

        setModalEditVisible(false)
    }
    async function handleModalSave()
    {
        if(Ppayid == undefined || Ppayid == null || Ppayid == '')
        {
            message.error("Please Key In Payment ID !!")
            return
        }
        if(Ppaydesc == undefined || Ppaydesc == null || Ppaydesc == '')
        {
            message.error("Please Key In Description !!")
            return
        }
        if(Pcurrency == undefined || Pcurrency == null || Pcurrency == '')
        {
            message.error("Please Select Currency !!")
            return
        }

        let data1 = {
            payid       : Ppayid,
            paydesc     : Ppaydesc,
            currency    : Pcurrency,
          
        }

        if(CreateForm == false)
        {
            data1.active = 1
        }

        setPogressStatus(true)
      
        var result1 = await onUpdatePaymentAcct(data1)

        if(result1.status == 'ok')
        {
            
            setdialogtitle("Update Successfully!")
            setdialogstatus("success")
            LoadPaymentAcctListing()
            setopendialog(true)
            setModalEditVisible(false)

            setPpayid('')
            setPpaydesc('')
            setPcurrency('')
        }
        else
        {
            setdialogtitle("Update fail, please contact IT!")
            setdialogstatus("error")
            setopendialog(true)
        }
        setPogressStatus(false)
        
    }
    var paymentacctcolumn = 
    [
        {
            title: <div>Payid</div>,
            dataIndex: 'payid',
            fixed: 'left',
            ...getColumnSearchProps('payid','Payid'),
        },  
        {
            title: <div>Description</div>,
            dataIndex: 'paydesc',
            ...getColumnSearchProps('paydesc','Description'),
        },  
        {
            title: <div>Currency</div>,
            dataIndex: 'currency',
            filters:Mcurrency,
            onFilter: (value, record) => record.currency.indexOf(value) === 0,
            
        },  
        {
          title: '',
          dataIndex: 'operation',
          width: '10%',
          render: (_, record) =>
            <>
                <IconButton onClick={() => handleModalOpen(record,1)}>
                <EditIcon style={{color:"seagreen",fontSize:"xx-large"}}></EditIcon>
                </IconButton>
            {
                record.active == 1 ?
                <>
                <IconButton onClick={() => UpdatePaymentAcctStatus(record)}>
                <ToggleOffIcon style={{color:"seagreen",fontSize:"xx-large"}}></ToggleOffIcon>
                </IconButton>
                </>
                :
                <>
                <IconButton onClick={() => UpdatePaymentAcctStatus(record)}>
                <ToggleOnIcon style={{color:"red",fontSize:"xx-large"}}></ToggleOnIcon>
                </IconButton>
                </>
            }
          
            </>
        },
    ]

    useEffect(() => {
      
        LoadPaymentAcctListing()
    
    },[])

    return (
        <>
         <Row justify="start">
            <div style={{width:"80%"}}>
            <Divider style={{paddingLeft:"10%"}}>{GetTranslation(userlang,prop.title) ?? "." }</Divider>
             </div>
             <div style={{width:"20%",display:"flex",alignItems:"center"}}>
                 <IconButton onClick={(val) => handleModalOpen('',2)}>
                 <AddCircleOutlineIcon style={{color:"blue"}}> 

                    </AddCircleOutlineIcon>
                 </IconButton>
                 
             </div>
           
        </Row>
        <Row>
            <div style={{width:"100%"}}>
            <Table
            bordered
            dataSource={Mpaymentacct}
            columns={paymentacctcolumn}
            size="small"
            pagination={false}
            >
                </Table>
            </div>
            
        </Row>
       <Modal
       visible={ModalEditVisible}
       title={"Edit"}
       onCancel={(val) =>handleModalClose()}
       footer={[
        <Button key="back" onClick={(val) =>handleModalClose()}>
          Return
        </Button>,
        <Button key="submit" type="primary" onClick={(val) => handleModalSave()}>
          Save
        </Button>,
       ]}
       >
        <Row>
            <div style={{width:"100%"}}>

           
            <div >
                <TextField
                style={{width:"100%"}}
                disabled={CreateForm}
                label="Payment ID"
                value={Ppayid}
                onChange={(val1) => setPpayid(val1.target.value)}
                InputLabelProps={{
                    shrink: true,
                }}
                />
            </div>
            <br/>
            <div >
                <TextField
                style={{width:"100%"}}
                label="Description"
                value={Ppaydesc}
                multiline={true}
                onChange={(val1) => setPpaydesc(val1.target.value)}
                InputLabelProps={{
                    shrink: true,
                }}
                />
            </div>
            <br/>
            <div>
            <Autocomplete
            freeSolo
            value={Pcurrency}
            onChange={(val1,val2) => Pcurrencychange(val2,1)}
            onInputChange={(val1,val2) => Pcurrencychange(val2,2)}
            inputValue={Pcurrency}
            options={Mcurrency}
            isOptionEqualToValue={(option, value) => option.value === value}
            renderInput={(params) => <TextField {...params} label="Bank" />}>
            </Autocomplete>
            </div>
            </div>
        </Row>

       </Modal>
       <Snackbar 
      anchorOrigin={{ vertical: "top", horizontal: "center" }} 
      open={opendialog} 
      autoHideDuration={6000} 
      onClose={handleSnackClose}>
        <Alert onClose={handleSnackClose} variant="filled" severity={dialogstatus}  sx={{ width: '100%' }}>
          {dialogtitle}
        </Alert>
      </Snackbar>
       <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={ProgressStatus}>
     
      <CircularProgress color="inherit" />
      </Backdrop>
        </>
    )

}